import React, { useState } from 'react';
import { FaChevronDown, FaDownload } from 'react-icons/fa';
import './ReportExtraData.css';
import PropTypes from 'prop-types';

import LifestyleImpact from '../LifeStyleImpact/LifeStyleImpact';

const ReportExtraData = ({ userData }) => {
  const currentTest = userData.testHistory[userData.testHistory.length - 1];
  //   const previousTest = userData.testHistory.length > 1 ? userData.testHistory[userData.testHistory.length - 2] : null;
  const hasMultipleTests = userData.testHistory.length > 1;
  const hasDecline = currentTest.trend === 'down';

  //   const [isDetailedAnalysisOpen, setIsDetailedAnalysisOpen] = useState(false);
  const [isLifestyleImpactOpen, setIsLifestyleImpactOpen] = useState(false);

  // const handleExportData = () => {
  //   const exportData = {
  //     userName: userData.name,
  //     exportDate: new Date().toISOString(),
  //     testHistory: userData.testHistory.map((test) => ({
  //       date: test.date,
  //       overallScore: test.overallScore,
  //       trend: test.trend,
  //       categories: test.categories,
  //     })),
  //   };

  //   const blob = new Blob([JSON.stringify(exportData, null, 2)], {
  //     type: 'application/json',
  //   });
  //   const url = URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = `fertility-metrics-${userData.name.toLowerCase()}-${new Date().toISOString().split('T')[0]}.json`;
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  //   URL.revokeObjectURL(url);
  // };

  return (
    <div className="report-extra-container">
      {/* --- Decline Alert --- */}
      {hasDecline && (
        <div className="alert danger">
          <p>⚠ Some metrics have declined since your last test. Consider consulting a fertility specialist or reviewing lifestyle factors.</p>
        </div>
      )}

      {/* --- Encouragement Alert --- */}
      {!hasMultipleTests && (
        <div className="alert info">
          <p>
            🎉 <strong>First test complete!</strong> This baseline establishes your starting point. Schedule your next test in 90 days to track
            improvements and optimize your fertility health.
          </p>
        </div>
      )}

      {/* --- Expert Consultation Section --- */}
      <div className="info-section">
        <h3>Expert Consultation</h3>
        <p>Connect with a fertility specialist via phone call to discuss:</p>
        <ul>
          <li>Comprehensive review of your test results and metrics</li>
          <li>What your results mean for your fertility journey</li>
          <li>Personalized action plan and guidance</li>
        </ul>
        <button className="primary-btn">Schedule for $49</button>
      </div>

      {/* --- Supplements Section --- */}
      <div className="info-section">
        <h3>Targeted Recommendations</h3>
        <p>Optimize your reproductive health with specialized male fertility supplements:</p>
        <ul>
          <li>Key nutrients that support sperm quality, count, and motility</li>
          <li>Targeted formula designed for male reproductive wellness</li>
          <li>Replace standard multivitamins with fertility-focused options</li>
        </ul>
        <button className="primary-btn">Get Supplements</button>
      </div>

      {/* --- Export Data Section --- */}
      <div className="info-section">
        <h3>Export Your Data</h3>
        <p>Download your complete fertility test data for analysis with other health tools:</p>
        <ul>
          <li>Compare with blood test results and biomarker data</li>
          <li>Correlate with fitness tracker and wearable device metrics</li>
          <li>Analyze trends across multiple health data sources</li>
        </ul>
        {/* <button onClick={handleExportData} className="primary-btn download-btn"> */}
        <button className="primary-btn download-btn">
          <FaDownload size={16} />
          <span>Download Data</span>
        </button>
      </div>
      {/* --- Lifestyle Impact Section --- */}
      <div className="collapsible-section">
        <div className="collapsible-header" onClick={() => setIsLifestyleImpactOpen(!isLifestyleImpactOpen)}>
          <div>
            <h2 className="section-title">Lifestyle Impact</h2>
            <p className="section-subtitle">Understand how various lifestyle habits impact semen quality and reproductive health</p>
          </div>
          <FaChevronDown className={`chevron ${isLifestyleImpactOpen ? 'rotate' : ''}`} />
        </div>

        {isLifestyleImpactOpen && (
          <div className="collapsible-content">
            <LifestyleImpact />
          </div>
        )}
      </div>
    </div>
  );
};

ReportExtraData.propTypes = {
  userData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    testHistory: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        trend: PropTypes.string,
        overallScore: PropTypes.number,
        categories: PropTypes.object, // could be refined further if desired
      })
    ).isRequired,
  }).isRequired,
};

export default ReportExtraData;
